import React, { Component } from "react";
import STable from "../../components/Common/STable";
import auth from "../../services/authService";
// import Checkbox from "../../components/Common/checkbox";
import NumberFormat from "react-number-format";
import authService from "../../services/authService";
var base64 = require("base-64");

class MonitorItemTable extends Component {
  columns = [
    // {
    //   path: "selected",
    //   label: " ",
    //   content: (item, index) => (
    //     <Checkbox
    //       onChange={() => this.props.handleCheckPrint(item, index)}
    //       isChecked={item.selected}
    //       id={`${index}Selected`}
    //     />
    //   )
    // },
    {
      path: "idx",
      label: "#",
      content: (item, index, currentPage, limit) => (
        <span>{index + 1 + limit * (currentPage - 1)}</span>
      ),
    },
    {
      path: "code",
      label: "Code",
    },
    {
      path: "customer_code",
      label: "Customer Code",
    },
    {
      path: "description",
      label: "Description",
    },
    // {
    //   path: "Is Production",
    //   label: "is_production",
    //   content: (item, index) => (
    //     <React.Fragment>
    //       {item.is_production === "1" ? (
    //         <i className="fa fa-check" style={{ color: "green" }} />
    //       ) : (
    //         <i className="fa fa-times" style={{ color: "red" }} />
    //       )}
    //     </React.Fragment>
    //   ),
    // },
    // {
    //   path: "weight_lbs_ft",
    //   label: "Weight lbs/ft",
    //   content: (item, index) => (
    //     <NumberFormat
    //       value={item.weight_lbs_ft}
    //       displayType={"text"}
    //       thousandSeparator={true}
    //     />
    //   ),
    // },
    // {
    //   path: "length_ft",
    //   label: "Length (ft)",
    //   content: (item, index) => (
    //     <NumberFormat
    //       value={item.length_ft}
    //       displayType={"text"}
    //       thousandSeparator={true}
    //     />
    //   ),
    // },
    {
      path: "cust_items",
      label: "Customer Drawing",
      content: (item, index) => (
        <NumberFormat
          onClick={()=>this.props.handleOpenDetailCustomer(item)}
          style={{textDecoration: 'underline', cursor: item.cust_items>0?'pointer':''}}
          value={item.cust_items}
          displayType={"text"}
          thousandSeparator={true}
        />
      ),
    },
    {
      path: "items",
      label: "Supplier Drawing",
      content: (item, index) => (
        <NumberFormat
          onClick={()=>this.props.handleOpenDetail(item)}
          style={{textDecoration: 'underline', cursor: item.items>0?'pointer':''}}
          value={item.items}
          displayType={"text"}
          thousandSeparator={true}
        />
      ),
    },
    // {
    //   path: "action",
    //   label: "action",
    //   content: (item, index) => (
    //     <div style={{ fontSize: "18px", minWidth: "125px" }}>
    //       {authService.getAkses("item", "UPDATE") === "1" && (
    //         <React.Fragment>
    //           <i
    //             style={{ cursor: "pointer", marginRight: "5px" }}
    //             title="Edit"
    //             onClick={() => this.props.gotoUpload(item)}
    //             className="fa fa-edit"
    //           />
    //           {item.is_production === "1" ? (
    //             <i
    //               style={{ cursor: "pointer", marginRight: "5px" }}
    //               title="Update"
    //               onClick={() => this.props.handleProduction(item, 0)}
    //               className="fa fa-times"
    //             />
    //           ) : (
    //             <i
    //               style={{ cursor: "pointer", marginRight: "5px" }}
    //               title="Update"
    //               onClick={() => this.props.handleProduction(item, 1)}
    //               className="pe-7s-tools"
    //             />
    //           )}
    //         </React.Fragment>
    //       )}
    //       {authService.getAkses("item", "UPDATE") === "1" && (
    //         <React.Fragment>
    //           <a
    //             href={`#/master/item/monitor/qc/${base64.encode(item.id_item)}`}
    //           >
    //             <i
    //               style={{
    //                 cursor: "pointer",
    //                 marginRight: "5px",
    //                 color: "black",
    //               }}
    //               title="QC"
    //               onClick={() => this.props.gotoQc(item)}
    //               className="fa fa-gears"
    //             />
    //           </a>
    //           <i
    //             style={{ cursor: "pointer", marginRight: "5px" }}
    //             title="Upload Packing"
    //             onClick={() => this.props.handleUploadPacking(item)}
    //             className="fa fa-upload"
    //           />
    //         </React.Fragment>
    //       )}
    //       <i
    //         style={{ cursor: "pointer", marginRight: "5px" }}
    //         title="Print"
    //         onClick={() => this.props.handlePrint(item)}
    //         className="fa fa-print"
    //       />
    //     </div>
    //   ),
    // },
  ];
  hideAction = (column) => {
    let col = column.filter(function (obj) {
      return obj.label !== "Status" && obj.path !== "is_under_hjm";
    });
    return col;
  };
  render() {
    const { items, from, sortColumn, onSort, ...rest } = this.props;
    return (
      <STable
        columns={this.columns}
        data={items}
        sortColumn={sortColumn}
        onSort={onSort}
        {...rest}
        keyId="id_item"
      />
    );
  }
}

export default MonitorItemTable;



// WEBPACK FOOTER //
// ./src/views/item/monitorItemTable.jsx